// extracted by mini-css-extract-plugin
module.exports = {"Accordion":"Accordion_Accordion__5B9Lx","Accordion_ref":"Accordion_Accordion_ref__pZ_J2","Accordion_heading":"Accordion_Accordion_heading__sw_Yh"};